import React, { useState } from "react";

import "./contact-form.scss";
import FAQ from "./FAQ";

import { Form, Input, Button, Select, Alert } from "antd";
import { countries } from "./region-const";

import paymentsService from "../../../../common/services/payments-service";

const { Option } = Select;

const ContactForm = () => {
  const [form] = Form.useForm();
  const [requiredMark, setRequiredMarkType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [countryStates, setCountryStates] = useState(null);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      await paymentsService.enterpriseContact(values);
      setSuccess(true);
    } catch (e) {
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  const onRequiredTypeChange = ({ requiredMarkValue }) => {
    setRequiredMarkType(requiredMarkValue);
  };

  const handleChange = (value) => {
    // eslint-disable-next-line array-callback-return
    countries.find((country) => {
      if (country.country === value) {
        setCountryStates(country.states);
      }
    });
  };

  return (
    <div className="main-container">
      <h1>Submit a request</h1>
      <div
        style={{
          width: "100%",
          padding: "5rem",
        }}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            requiredMarkValue: requiredMark,
          }}
          onValuesChange={onRequiredTypeChange}
          requiredMark={requiredMark}
          onFinish={handleSubmit}
        >
          <Form.Item
            label="Country/Region"
            required
            tooltip="This is a required field"
            name="country"
          >
            <Select
              onChange={handleChange}
              placeholder="Please select a country"
            >
              {countries?.map((item, index) => (
                <Option value={item.country} key={index}>
                  {item.country}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="State/Province"
            required
            tooltip="This is a required field"
            name="state"
          >
            <Select placeholder="Please select a country">
              {countryStates?.map((item, index) => (
                <Option value={item} key={index}>
                  {item}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="email" label="Email">
            <Input
              placeholder=" Email address"
              className="test"
              style={{
                backgroundColor: "#212121",
                border: "1px solid #707070",
                color: "#E5E5E5",
              }}
            />
          </Form.Item>
          <Form.Item name="company" label="Organization name">
            <Input
              placeholder=" Organization "
              className="test"
              style={{
                backgroundColor: "#212121",
                border: "1px solid #707070",
                color: "#E5E5E5",
              }}
            />
          </Form.Item>

          <Form.Item name="message" label="Message">
            <Input.TextArea
              style={{
                backgroundColor: "#212121",
                border: "1px solid #707070",
                height: "300px",
                color: "#E5E5E5",
              }}
            />
          </Form.Item>
          <Form.Item>
            {!success ? (
              <Button
                className="send-btn"
                type="primary"
                style={{
                  width: "100%",
                  backgroundColor: "#256AFE",
                  border: "none",
                }}
                htmlType="submit"
                loading={isLoading}
              >
                Send
              </Button>
            ) : (
              <Alert
                message="Message Sent! We will get back with you very soon."
                type="success"
                showIcon
              />
            )}
          </Form.Item>
        </Form>
      </div>
      <FAQ />
    </div>
  );
};
export default ContactForm;
